import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowLeft, Users, GraduationCap, UserCheck, UserPlus } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AsistentesPage = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    exalumnos: 0,
    maestros: 0,
    invitados: 0,
    total: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/asistentes/stats`);
      setStats(response.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-warm-bone">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-zuno-wine"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-warm-bone py-12">
      <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-4xl">
        <Button
          onClick={() => navigate("/")}
          variant="ghost"
          className="mb-8"
          data-testid="back-button"
        >
          <ArrowLeft className="mr-2" size={20} />
          Volver al Inicio
        </Button>

        <div className="glass-card rounded-3xl p-8 md:p-12">
          <div className="flex items-center gap-4 mb-8">
            <Users className="h-12 w-12 text-zuno-wine" />
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-zuno-wine">
                Asistentes Confirmados
              </h1>
              <p className="text-lg text-slate-600 mt-2">
                Resumen de boletos por categoría
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-8">
            {/* Exalumnos */}
            <Card className="p-6 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-testid="card-exalumnos">
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-blue-500 text-white rounded-full p-3 flex-shrink-0">
                  <GraduationCap size={24} />
                </div>
                <h3 className="text-lg font-semibold text-blue-800 leading-tight">Exalumnos<br/>93-96</h3>
              </div>
              <p className="text-5xl font-bold text-blue-600 text-center">
                {stats.exalumnos}
              </p>
              <p className="text-center text-blue-600 mt-2">boletos</p>
            </Card>

            {/* Maestros */}
            <Card className="p-6 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-testid="card-maestros">
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-green-500 text-white rounded-full p-3">
                  <UserCheck size={28} />
                </div>
                <h3 className="text-xl font-semibold text-green-800">Maestros</h3>
              </div>
              <p className="text-5xl font-bold text-green-600 text-center">
                {stats.maestros}
              </p>
              <p className="text-center text-green-600 mt-2">boletos</p>
            </Card>

            {/* Invitados */}
            <Card className="p-6 bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200" data-testid="card-invitados">
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-purple-500 text-white rounded-full p-3">
                  <UserPlus size={28} />
                </div>
                <h3 className="text-xl font-semibold text-purple-800">Invitados</h3>
              </div>
              <p className="text-5xl font-bold text-purple-600 text-center">
                {stats.invitados}
              </p>
              <p className="text-center text-purple-600 mt-2">boletos</p>
            </Card>
          </div>

          {/* Total */}
          <Card className="p-8 bg-gradient-to-br from-zuno-wine to-slate-800 text-white" data-testid="card-total">
            <div className="text-center">
              <h3 className="text-2xl font-semibold mb-4">Total de Boletos Confirmados</h3>
              <p className="text-7xl font-bold">{stats.total}</p>
              <p className="text-xl mt-4 opacity-80">
                ¡Nos vemos el 20 de Junio!
              </p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AsistentesPage;
